window.ON_CHANGE_DEBOUNCE_TIMER = 300;

window.PUB_SUB_EVENTS = {
    cartClear: 'cart-clear',
    cartUpdate: 'cart-update',
    quantityUpdate: 'quantity-update',
    // optionValueSelectionChange: 'option-value-selection-change',
    variantChange: 'variant-change',
    cartError: 'cart-error',
};

if (!window.setCookie) {
    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }
    window.setCookie = setCookie;
}

if (!window.getCookie) {
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
    window.getCookie = getCookie;
}

if (!window.formatWithDelimiters) {
    /**
     * Formats a number of cents into a currency string using the provided
     * precision, thousands separator, and decimal separator.
     * @param number - The number of cents to format.
     * @param precision - The number of decimal places to include.
     * @param thousands - The character to use as the thousands separator.
     * @param decimal - The character to use as the decimal separator.
     * @returns The formatted currency string.
     */
    function formatWithDelimiters(
        number,
        precision = 2,
        thousands = ",",
        decimal = ".",
    ) {
        if (isNaN(number) || number == null) {
            return "0";
        }

        const numString = (number / 100.0).toFixed(precision);
        const parts = numString.split(".");
        const dollars = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            "$1" + thousands,
        );
        const cents = parts[1] ? decimal + parts[1] : "";
        return dollars + cents;
    }
    window.formatWithDelimiters = formatWithDelimiters;
}

if (!window.formatMoney) {
    function formatMoney(cents, formatString) {
        formatString = formatString || window.money_with_currency_format;

        const placeholderRegex = /{{\s*(\w+)\s*}}/;
        return formatString.replace(placeholderRegex, (match, placeholder) => {
            switch (placeholder) {
                case "amount":
                    // Ex.	1,134.65
                    return formatWithDelimiters(cents, 2);
                case "amount_no_decimals":
                    // Ex. 1,135
                    return formatWithDelimiters(cents, 0);
                case "amount_with_comma_separator":
                    // Ex. 1.134,65
                    return formatWithDelimiters(cents, 2, ".", ",");
                case "amount_no_decimals_with_comma_separator":
                    // Ex. 1.135
                    return formatWithDelimiters(cents, 0, ".", ",");
                case "amount_with_apostrophe_separator":
                    // Ex. 1'134.65
                    return formatWithDelimiters(cents, 2, "'", ".");
                case "amount_no_decimals_with_space_separator":
                    // Ex. 1 135
                    return formatWithDelimiters(cents, 0, " ");
                case "amount_with_space_separator":
                    // 1 134,65
                    return formatWithDelimiters(cents, 2, " ", ",");
                case "amount_with_period_and_space_separator":
                    // 1 134.65
                    return formatWithDelimiters(cents, 2, " ", ".");
                default:
                    return match;
            }
        });
    }
    window.formatMoney = formatMoney;
}

if (!window.debounce) {
    function debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
    window.debounce = debounce;
}

if (!window.afterNextPaint) {
    /**
     * Runs `callback` once the browser has painted the current frame, so work the user
     * does not see right away stays out of the interaction that triggered it (INP).
     */
    function afterNextPaint(callback) {
        // Hidden tabs get no animation frames, so there is no paint to wait for.
        if (document.visibilityState === 'hidden') {
            setTimeout(callback, 0);
            return;
        }

        requestAnimationFrame(() => setTimeout(callback, 0));
    }
    window.afterNextPaint = afterNextPaint;
}

if (!window.updateHistoryAfterPaint) {
    /**
     * history.pushState/replaceState are wrapped by the analytics scripts (Meta Pixel,
     * Clarity, GTM), which run 100-200ms of work synchronously on every call. Calling
     * them inside a click handler delays the next paint by that much, so the URL is
     * updated after the paint instead, and calls made in the same frame collapse into
     * one (a pushState among them wins, so a history entry is never lost).
     */
    let pendingHistoryUpdate = null;

    function updateHistoryAfterPaint(url, state = {}, method = 'replaceState') {
        const isScheduled = pendingHistoryUpdate !== null;
        const keepPush = isScheduled && pendingHistoryUpdate.method === 'pushState';
        pendingHistoryUpdate = { url, state, method: keepPush ? 'pushState' : method };

        if (isScheduled) {
            return;
        }

        afterNextPaint(() => {
            const update = pendingHistoryUpdate;
            pendingHistoryUpdate = null;

            const isSameUrl = new URL(update.url, window.location.href).href === window.location.href;
            if (update.method === 'replaceState' && isSameUrl && !Object.keys(update.state).length) {
                return;
            }

            window.history[update.method](update.state, '', update.url);
        });
    }
    window.updateHistoryAfterPaint = updateHistoryAfterPaint;
}

if (!window.dispatchCustomEvent) {
    function dispatchCustomEvent(eventName) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var detail = {
            detail: data
        };
        var event = new CustomEvent(eventName, data ? detail : null);
        document.dispatchEvent(event);
    }
    window.dispatchCustomEvent = dispatchCustomEvent;
}

if (!window.getSectionInnerHTML) {
    function getSectionInnerHTML(html, selector) {
        const el = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector);

        if (!el) {
            return '';
        }

        return el.innerHTML;
    }
    window.getSectionInnerHTML = getSectionInnerHTML;
}

function scrollToId(id) {
    document.getElementById(id).scrollIntoView({ behavior: 'smooth', block: 'center' });
}

if (!window.fetchConfig) {
    function fetchConfig(type = 'json') {
        return {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
        };
    }
    window.fetchConfig = fetchConfig;
}

if (!window.subscribers) {
    window.subscribers = {};
}

if (!window.subscribe) {
    function subscribe(eventName, callback) {
        if (subscribers[eventName] === undefined) {
            subscribers[eventName] = [];
        }

        subscribers[eventName] = [...subscribers[eventName], callback];

        return function unsubscribe() {
            subscribers[eventName] = subscribers[eventName].filter((cb) => {
                return cb !== callback;
            });
        };
    }
    window.subscribe = subscribe;
}

if (!window.publish) {
    function publish(eventName, data) {
        if (subscribers[eventName]) {
            const promises = subscribers[eventName]
                .map((callback) => callback(data))
            return Promise.all(promises);
        } else {
            return Promise.resolve()
        }
    }
    window.publish = publish;
}

if (!window.getFocusableElements) {
    function getFocusableElements(container) {
        return Array.from(
            container.querySelectorAll(
                "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
            )
        );
    }
    window.getFocusableElements = getFocusableElements;
}

if (!window.trapFocusHandlers) {
    window.trapFocusHandlers = {};
}

if (!window.trapFocus) {
    function trapFocus(container, elementToFocus = container) {
        var elements = getFocusableElements(container);
        var first = elements[0];
        var last = elements[elements.length - 1];

        removeTrapFocus();

        trapFocusHandlers.focusin = (event) => {
            if (event.target !== container && event.target !== last && event.target !== first) return;

            document.addEventListener('keydown', trapFocusHandlers.keydown);
        };

        trapFocusHandlers.focusout = function () {
            document.removeEventListener('keydown', trapFocusHandlers.keydown);
        };

        trapFocusHandlers.keydown = function (event) {
            if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
            // On the last focusable element and tab forward, focus the first element.
            if (event.target === last && !event.shiftKey) {
                event.preventDefault();
                first.focus();
            }

            //  On the first focusable element and tab backward, focus the last element.
            if ((event.target === container || event.target === first) && event.shiftKey) {
                event.preventDefault();
                last.focus();
            }
        };

        document.addEventListener('focusout', trapFocusHandlers.focusout);
        document.addEventListener('focusin', trapFocusHandlers.focusin);

        elementToFocus.focus();

        if (
            elementToFocus.tagName === 'INPUT' &&
            ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
            elementToFocus.value
        ) {
            elementToFocus.setSelectionRange(0, elementToFocus.value.length);
        }
    }
    window.trapFocus = trapFocus;
}

if (!window.removeTrapFocus) {
    function removeTrapFocus(elementToFocus = null) {
        document.removeEventListener('focusin', trapFocusHandlers.focusin);
        document.removeEventListener('focusout', trapFocusHandlers.focusout);
        document.removeEventListener('keydown', trapFocusHandlers.keydown);

        if (elementToFocus) elementToFocus.focus();
    }
    window.removeTrapFocus = removeTrapFocus;
}

class CartPerformance {
    static #metric_prefix = "cart-performance"

    static createStartingMarker(benchmarkName) {
        const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
        return performance.mark(`${metricName}:start`);
    }

    static measureFromEvent(benchmarkName, event) {
        const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
        const startMarker = performance.mark(`${metricName}:start`, {
            startTime: event.timeStamp
        });

        const endMarker = performance.mark(`${metricName}:end`);

        performance.measure(
            metricName,
            `${metricName}:start`,
            `${metricName}:end`
        );
    }

    static measureFromMarker(benchmarkName, startMarker) {
        const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
        const endMarker = performance.mark(`${metricName}:end`);

        performance.measure(
            metricName,
            startMarker.name,
            `${metricName}:end`
        );
    }

    static measure(benchmarkName, callback) {
        const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
        const startMarker = performance.mark(`${metricName}:start`);

        callback();

        const endMarker = performance.mark(`${metricName}:end`);

        performance.measure(
            metricName,
            `${metricName}:start`,
            `${metricName}:end`
        );
    }
}

document.addEventListener('DOMContentLoaded', function() {
    {
        let globalExitTimeout = null;
        let globalEnterTimeout = null;

        const menu = document.querySelector('.header__menu');
        if (menu) {
            menu.addEventListener('mouseover', (e) => {
                let item = e.target.closest('.megamenu__trigger');
                if (!item) {
                    return;
                }

                clearTimeout(globalExitTimeout);

                if (!item.classList.contains('hover')) {
                    clearTimeout(globalEnterTimeout);

                    globalEnterTimeout = setTimeout(() => {
                        document.querySelectorAll('.megamenu__trigger.hover').forEach(el => {
                            if (el !== item) el.classList.remove('hover');
                        });
                        item.classList.add('hover');
                    }, 150);
                }
            });

            menu.addEventListener('mouseout', (e) => {
                let item = e.target.closest('.megamenu__trigger');
                if (!item) {
                    return;
                }

                clearTimeout(globalEnterTimeout);

                globalExitTimeout = setTimeout(() => {
                    item.classList.remove('hover');
                }, 150);
            });
        }
    }

    {
        const customSelects = document.querySelectorAll('.custom__select');

        function toggleDropdown(dropdown, selectButton, expand = null) {
            const isOpen = expand !== null ? expand : dropdown.classList.contains('hidden');
            dropdown.classList.toggle('hidden', !isOpen);
            selectButton.setAttribute('aria-expanded', isOpen);
        }

        customSelects.forEach(function(customSelect) {
            const selectButton = customSelect.querySelector('.custom__select__button');
            const dropdown = customSelect.querySelector('.custom__select__dropdown');
            const options = dropdown.querySelectorAll('option');
            const selectedValue = selectButton.querySelector('.custom__select__selected');
            const selectInput = customSelect.querySelector('input');
            const submitOnSelect = customSelect.dataset.submitOnSelect;
            const multiple = customSelect.dataset.multiple;
            let resetSearchTimeout;
            let searchKey = '';

            function handleOptionSelect(option) {
                if (!multiple) {
                    options.forEach(function (opt) {
                        opt.classList.remove('selected');
                        opt.removeAttribute('selected');
                    });
                }

                if (option.value) {
                    option.toggleAttribute('selected');
                    option.classList.toggle('selected');
                } else if (multiple) {
                    options.forEach(function (opt) {
                        opt.classList.remove('selected');
                        opt.removeAttribute('selected');
                        opt.selected = false;
                    });
                }

                if (!selectButton.classList.contains('custom__select__button--icon')) {
                    if (!multiple) {
                        selectedValue.innerHTML = option.innerHTML.trim();
                    } else {
                        if (option.value) {
                            let selectedOptions = [];

                            options.forEach(function (opt) {
                                if (opt.selected) {
                                    selectedOptions.push(opt);;
                                }
                            });

                            let selectedTitle = '';
                            if (!selectedOptions.length) {
                                selectedTitle = options[0].textContent;
                            } else {
                                selectedTitle = selectedOptions[0].textContent;
                                if (selectedOptions.length > 1) {
                                    selectedTitle += ` +${selectedOptions.length - 1}`;
                                }
                            }

                            selectedValue.textContent = selectedTitle
                        } else {
                            selectedValue.textContent = options[0].textContent;
                        }
                    }
                }

                if (selectInput) {
                    selectInput.value = option.value;
                }

                if (submitOnSelect && !multiple) {
                    const selectForm = option.closest('form');
                    if (selectForm) {
                        selectForm.submit();
                    }
                }
            }

            options.forEach((option) => {
                option.addEventListener('click', (e) => {
                    handleOptionSelect(option);
                    if (!multiple || !option.value) {
                        toggleDropdown(dropdown, selectButton, false);
                    }

                    customSelect.dispatchEvent(new Event('change'));
                });
            });

            selectButton.addEventListener('click', () => {
                toggleDropdown(dropdown, selectButton);
            });

            customSelect.addEventListener('keydown', (e) => {
                if (e.keyCode >= 48 && e.keyCode <= 90) {
                    if (resetSearchTimeout) {
                        clearTimeout(resetSearchTimeout);
                    }

                    resetSearchTimeout = setTimeout(() => {
                        searchKey = '';
                    }, 1500);

                    searchKey += String.fromCharCode(e.keyCode);

                    for (let i = 0, l = options.length; i < l; i++) {
                        if (options[i].text.toUpperCase().substr(0, searchKey.length) === searchKey) {
                            handleOptionSelect(options[i]);
                            options[i].scrollIntoView({
                                behavior: 'smooth',
                                block: 'start'
                            })
                        }
                    }
                }
            });

            document.addEventListener('click', async (event)  => {
                const isOutsideClick = !customSelect.contains(event.target);

                if (isOutsideClick) {
                    toggleDropdown(dropdown, selectButton, false);
                }
            });
        });
    }
});
